document.addEventListener('DOMContentLoaded', () => {
  console.log('custom-swatch.js loaded'); // Debug
  // Cambio immagine e aggiornamento variante quando si seleziona uno swatch
  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
    console.log('Swatch change event:', event); // Debug
    const { target } = event.data;
    const imageUrl = target.dataset.image;
    const variantId = target.dataset.variantId;
    if (imageUrl) {
      const card = target.closest('.card-wrapper');
      if (card) {
        const mainImage = card.querySelector('.media img:first-child');
        if (mainImage) {
          mainImage.src = imageUrl;
          mainImage.srcset = imageUrl;
        }
        // Aggiorna la variante selezionata per il pulsante Quick Add
        const quickAddForm = card.querySelector('product-form form');
        if (quickAddForm) {
          const variantInput = quickAddForm.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variantId;
          }
        }
        const quickAddBulk = card.querySelector('quick-add-bulk');
        if (quickAddBulk) {
          quickAddBulk.setAttribute('data-index', variantId);
        }
      }
    }
  });

  // Accessibilità da tastiera per gli swatch
  document.querySelectorAll('.swatch-color').forEach((swatch) => {
    swatch.addEventListener('keydown', (event) => {
      if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        const input = swatch.closest('.product-form__input').querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  // Integrazione con il pulsante Quick Add
  document.querySelectorAll('.quick-add__submit').forEach((button) => {
    button.addEventListener('click', (event) => {
      const bulkAdd = document.querySelector('bulk-add');
      if (bulkAdd) {
        const id = event.currentTarget.closest('.card-wrapper').querySelector('quick-add-bulk')?.dataset.index || event.currentTarget.closest('form')?.querySelector('input[name="id"]')?.value;
        if (id) {
          bulkAdd.startQueue(id, 1); // Quantità predefinita = 1
        }
      }
    });
  });
});





/* =========================================================
   DH — Collection, featured collection and recommendations swatch overlay
   Additive module: does not replace or rewrite the code above.
   ========================================================= */
(function () {
  if (window.__DH_CARD_SWATCH_PREVIEW_INIT__) return;
  window.__DH_CARD_SWATCH_PREVIEW_INIT__ = true;

  var finePointerQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine) and (min-width: 750px)'
  );
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var cardStates = new Set();
  var modelSearchCache = new Map();
  var productUrlCache = new Map();

  function normalizeLookupValue(value) {
    var normalized = String(value || '').trim().toLowerCase();

    try {
      normalized = normalized
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}

    return normalized.replace(/\s+/g, ' ');
  }

  function productLookupKey(productTitle, colorName) {
    return (
      normalizeLookupValue(productTitle) +
      '::' +
      normalizeLookupValue(colorName)
    );
  }

  function cleanProductUrl(rawUrl) {
    if (!rawUrl) return '';

    try {
      var parsedUrl = new URL(rawUrl, window.location.origin);
      parsedUrl.search = '';
      parsedUrl.hash = '';

      return parsedUrl.origin === window.location.origin
        ? parsedUrl.pathname
        : parsedUrl.href;
    } catch (e) {
      return rawUrl;
    }
  }

  function readProductCardRecord(card) {
    if (!card || !card.querySelector) return null;

    var swatches = card.querySelector('.dh-card-swatches');
    var productLink = card.querySelector(
      'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"], .card__heading a.full-unstyled-link'
    );

    if (!swatches || !productLink) return null;

    var primaryInput =
      swatches.querySelector('input[type="radio"][checked]') ||
      swatches.querySelector('input[type="radio"]:checked') ||
      swatches.querySelector('input[type="radio"]');
    var productTitle =
      swatches.dataset.dhProductTitle || productLink.textContent || '';
    var primaryColor =
      swatches.dataset.dhPrimaryColor ||
      (primaryInput && primaryInput.dataset
        ? primaryInput.dataset.color || primaryInput.value
        : '');
    var productUrl = cleanProductUrl(
      swatches.dataset.dhProductUrl || productLink.getAttribute('href')
    );

    if (!productTitle || !primaryColor || !productUrl) return null;

    return {
      color: primaryColor,
      title: productTitle,
      url: productUrl
    };
  }

  function registerProductCard(card) {
    var record = readProductCardRecord(card);
    if (!record) return null;

    productUrlCache.set(
      productLookupKey(record.title, record.color),
      record.url
    );

    return record;
  }

  function searchPageUrl(productTitle) {
    var root = '/';

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      root = window.Shopify.routes.root;
    }

    root = String(root || '/').replace(/\/?$/, '/');

    return (
      root +
      'search?q=' +
      window.encodeURIComponent(productTitle) +
      '&type=product'
    );
  }

  function loadModelProductUrls(productTitle) {
    var normalizedTitle = normalizeLookupValue(productTitle);
    if (!normalizedTitle) return Promise.resolve(false);

    if (modelSearchCache.has(normalizedTitle)) {
      return modelSearchCache.get(normalizedTitle);
    }

    var request = window
      .fetch(searchPageUrl(productTitle), {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product color search failed: ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var parsedDocument = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        parsedDocument
          .querySelectorAll('.product-card-wrapper')
          .forEach(function (candidateCard) {
            var candidate = registerProductCard(candidateCard);

            if (
              candidate &&
              normalizeLookupValue(candidate.title) !== normalizedTitle
            ) {
              productUrlCache.delete(
                productLookupKey(candidate.title, candidate.color)
              );
            }
          });

        return true;
      })
      .catch(function (error) {
        console.warn('[DH swatches] Product-color lookup unavailable.', error);
        return false;
      });

    modelSearchCache.set(normalizedTitle, request);
    return request;
  }

  function resolveSwatchProductUrl(state, swatch) {
    var input = getInputForSwatch(swatch);
    var productTitle = state.swatches.dataset.dhProductTitle || '';
    var colorName =
      input && input.dataset
        ? input.dataset.color || input.value || ''
        : '';
    var key = productLookupKey(productTitle, colorName);
    var cachedUrl = productUrlCache.get(key);

    if (cachedUrl) return Promise.resolve(cachedUrl);

    return loadModelProductUrls(productTitle).then(function () {
      return productUrlCache.get(key) || '';
    });
  }

  function selectSwatchWithoutNavigation(swatch) {
    var input = getInputForSwatch(swatch);
    if (!input) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function resetProductNavigationState(state) {
    if (!state) return;

    window.clearTimeout(state.productNavigationTimer);
    state.productNavigationTimer = null;
    state.productNavigationPending = false;

    state.swatches
      .querySelectorAll('[aria-busy="true"]')
      .forEach(function (swatch) {
        swatch.removeAttribute('aria-busy');
      });
  }

  function resetAllProductNavigationStates() {
    cardStates.forEach(resetProductNavigationState);
  }

  function openColorProduct(state, swatch) {
    if (!state || !swatch || state.productNavigationPending) return;

    // Nel Theme Editor evita di cambiare direttamente l'URL dell'iframe:
    // Shopify deve gestire la navigazione per aggiornare anche il template.
    if (window.Shopify && window.Shopify.designMode) {
      selectSwatchWithoutNavigation(swatch);
      return;
    }

    state.productNavigationPending = true;
    swatch.setAttribute('aria-busy', 'true');

    /*
      Safari may cancel a navigation or restore this page from its back-forward
      cache. This timer prevents a card from remaining permanently locked.
    */
    window.clearTimeout(state.productNavigationTimer);
    state.productNavigationTimer = window.setTimeout(function () {
      resetProductNavigationState(state);
    }, 2500);

    resolveSwatchProductUrl(state, swatch).then(function (productUrl) {
      if (productUrl) {
        window.location.assign(productUrl);
        return;
      }

      resetProductNavigationState(state);
      selectSwatchWithoutNavigation(swatch);
    });
  }

  function clearColorLabel(state) {
    if (!state) return;

    window.clearTimeout(state.colorNameTimer);
    state.colorNameTimer = null;

    if (state.colorList) {
      state.colorList.classList.remove('dh-color-name-visible');
      state.colorList.removeAttribute('data-dh-active-color-name');
    }
  }

  function showColorLabel(state, colorName) {
    if (!state || !state.colorList || !colorName) return;

    clearColorLabel(state);
    state.colorList.setAttribute('data-dh-active-color-name', colorName);
    state.colorNameTimer = window.setTimeout(function () {
      if (state.activeSwatch) {
        state.colorList.classList.add('dh-color-name-visible');
      }
    }, 350);
  }

  function readImageState(image) {
    return {
      src: image.getAttribute('src'),
      srcset: image.getAttribute('srcset')
    };
  }

  function writeImageState(image, imageState) {
    if (!image || !imageState) return;

    if (imageState.src) {
      image.setAttribute('src', imageState.src);
    } else {
      image.removeAttribute('src');
    }

    if (imageState.srcset) {
      image.setAttribute('srcset', imageState.srcset);
    } else {
      image.removeAttribute('srcset');
    }
  }

  function getInputForSwatch(swatch) {
    if (!swatch) return null;

    if (swatch.htmlFor) {
      return document.getElementById(swatch.htmlFor);
    }

    var wrapper = swatch.closest('.product-form__input');
    return wrapper ? wrapper.querySelector('input[type="radio"]') : null;
  }

  function endPreview(state) {
    if (!state || !state.mainImage || !state.media) return;

    state.previewToken += 1;
    state.activeSwatch = null;
    state.media.classList.remove('dh-swatch-preview-active');
    clearColorLabel(state);

    if (state.baseImageState) {
      writeImageState(state.mainImage, state.baseImageState);
    }

    state.baseImageState = null;
  }

  function closeMobileCard(state) {
    if (!state) return;
    state.card.classList.remove('dh-mobile-card-open');
    disarmMobileFirstTap(state);
  }

  function disarmMobileFirstTap(state) {
    if (!state || !state.mobileFirstTapArmed) return;

    window.clearTimeout(state.mobileFirstTapTimer);
    state.mobileFirstTapTimer = null;
    state.mobileFirstTapArmed = false;

    if (state.mediaContainerHadRole) {
      state.mediaContainer.setAttribute('role', state.mediaContainerRole);
    } else {
      state.mediaContainer.removeAttribute('role');
    }
  }

  function armMobileFirstTap(state) {
    if (!state || state.mobileFirstTapArmed) return;

    state.mobileFirstTapArmed = true;
    state.mediaContainerHadRole = state.mediaContainer.hasAttribute('role');
    state.mediaContainerRole = state.mediaContainer.getAttribute('role');

    /*
      custom.js intercetta i click immagine in capture sul document e ignora
      gli elementi con role="button". Il ruolo temporaneo blocca soltanto il
      primo gesto; viene ripristinato appena quel click è terminato.
    */
    state.mediaContainer.setAttribute('role', 'button');
    state.mobileFirstTapTimer = window.setTimeout(function () {
      disarmMobileFirstTap(state);
    }, 1200);
  }

  function closeOtherMobileCards(currentState) {
    cardStates.forEach(function (state) {
      if (state !== currentState) closeMobileCard(state);
    });
  }

  function showPreview(state, swatch) {
    var input = getInputForSwatch(swatch);
    var imageUrl = input && input.dataset ? input.dataset.image : '';

    if (!imageUrl || !state || !state.mainImage || !state.media) return;

    if (!state.baseImageState) {
      state.baseImageState = readImageState(state.mainImage);
    }

    state.activeSwatch = swatch;
    state.previewToken += 1;
    var token = state.previewToken;
    var preloader = new Image();

    function applyPreview() {
      if (token !== state.previewToken || state.activeSwatch !== swatch) return;

      writeImageState(state.mainImage, {
        src: imageUrl,
        srcset: imageUrl
      });
      state.media.classList.add('dh-swatch-preview-active');
    }

    preloader.addEventListener('load', applyPreview, { once: true });
    preloader.src = imageUrl;

    if (preloader.complete) applyPreview();
  }

  function restoreSwatchPosition(state) {
    if (!state.placeholder.parentNode) return;

    state.placeholder.parentNode.insertBefore(
      state.swatches,
      state.placeholder.nextSibling
    );
    state.swatches.classList.remove('dh-card-swatches--overlay');
    state.swatches.classList.remove('dh-card-swatches--mobile-overlay');
    closeMobileCard(state);
    endPreview(state);
  }

  function updateSwatchPosition(state) {
    if (!state.card.isConnected) {
      cardStates.delete(state);
      return;
    }

    if (finePointerQuery.matches) {
      state.mediaContainer.appendChild(state.swatches);
      state.swatches.classList.remove('dh-card-swatches--mobile-overlay');
      state.swatches.classList.add('dh-card-swatches--overlay');
      closeMobileCard(state);
    } else if (mobileQuery.matches) {
      state.mediaContainer.appendChild(state.swatches);
      state.swatches.classList.remove('dh-card-swatches--overlay');
      state.swatches.classList.add('dh-card-swatches--mobile-overlay');
      endPreview(state);
    } else {
      restoreSwatchPosition(state);
    }
  }

  function prepareSwatch(state, swatch) {
    if (swatch.dataset.dhPreviewReady === 'true') return;

    var input = getInputForSwatch(swatch);
    var colorName =
      swatch.getAttribute('title') ||
      (input && input.dataset ? input.dataset.color : '') ||
      (input ? input.value : '') ||
      '';

    swatch.dataset.dhPreviewReady = 'true';
    swatch.dataset.dhColorName = colorName;

    // Il tooltip CSS sostituisce quello nativo e applica un ritardo controllato.
    swatch.removeAttribute('title');

    swatch.addEventListener('pointerenter', function () {
      if (!finePointerQuery.matches) return;
      showPreview(state, swatch);
      showColorLabel(state, colorName);
    });

    swatch.addEventListener('focus', function () {
      if (!finePointerQuery.matches) return;
      showPreview(state, swatch);
      showColorLabel(state, colorName);
    });

    /* Desktop: a color opens the separate primary product for that color. */
    swatch.addEventListener('click', function (event) {
      if (!finePointerQuery.matches) return;

      event.preventDefault();
      event.stopPropagation();
      openColorProduct(state, swatch);
    });

    swatch.addEventListener('keydown', function (event) {
      if (!finePointerQuery.matches) return;
      if (event.code !== 'Enter' && event.code !== 'Space') return;

      event.preventDefault();
      event.stopPropagation();
      openColorProduct(state, swatch);
    });
  }

  function prepareCard(card) {
    if (card.dataset.dhVariantOverlayReady === 'true') return;

    /*
      Apply the same card interaction in the collection grid, Dawn's featured
      collection slider and product recommendations. Other product-card
      carousels (recently viewed, complementary products, etc.) stay untouched.
    */
    var supportedContainer =
      card.closest('#product-grid') ||
      card.closest('.collection slider-component') ||
      card.closest('product-recommendations');

    if (!supportedContainer) return;

    var swatches = card.querySelector('.dh-card-swatches');
    var mediaContainer = card.querySelector('.card__inner');
    var media = card.querySelector('.card__media .media');
    var mainImage = media ? media.querySelector('img:first-child') : null;
    var colorList = swatches ? swatches.querySelector('.color-swatch-list') : null;

    if (!swatches || !colorList || !mediaContainer || !media || !mainImage) return;

    card.classList.add('dh-variant-overlay-card');

    var placeholder = document.createComment('dh-card-swatches-position');
    swatches.parentNode.insertBefore(placeholder, swatches);

    var state = {
      activeSwatch: null,
      baseImageState: null,
      card: card,
      colorList: colorList,
      colorNameTimer: null,
      mainImage: mainImage,
      media: media,
      mediaContainer: mediaContainer,
      mediaContainerHadRole: false,
      mediaContainerRole: null,
      mobileFirstTapArmed: false,
      mobileFirstTapTimer: null,
      placeholder: placeholder,
      previewToken: 0,
      productNavigationPending: false,
      productNavigationTimer: null,
      swatches: swatches
    };

    card.dataset.dhVariantOverlayReady = 'true';
    cardStates.add(state);

    var productRecord = registerProductCard(card);
    if (productRecord && finePointerQuery.matches) {
      window.setTimeout(function () {
        loadModelProductUrls(productRecord.title);
      }, 0);
    }

    swatches.querySelectorAll('.swatch-color').forEach(function (swatch) {
      prepareSwatch(state, swatch);
    });

    /*
      Desktop: the preview remains stable while crossing the gaps between
      swatches and ends only after leaving the complete swatch area.
    */
    swatches.addEventListener('pointerleave', function () {
      if (finePointerQuery.matches) endPreview(state);
    });

    swatches.addEventListener('focusout', function (event) {
      if (
        finePointerQuery.matches &&
        (!event.relatedTarget || !swatches.contains(event.relatedTarget))
      ) {
        endPreview(state);
      }
    });

    /* Swatch taps must never trigger the card navigation on mobile. */
    swatches.addEventListener('pointerdown', function (event) {
      if (mobileQuery.matches) event.stopPropagation();
    });

    swatches.addEventListener('click', function (event) {
      if (mobileQuery.matches) event.stopPropagation();
    });

    /*
      Il listener immagine di custom.js è in capture sul document, quindi il
      primo tap va marcato già al pointerdown, prima che nasca l'evento click.
    */
    mediaContainer.addEventListener(
      'pointerdown',
      function (event) {
        if (!mobileQuery.matches) return;
        if (event.target.closest('.dh-card-swatches')) return;
        if (state.card.classList.contains('dh-mobile-card-open')) return;

        armMobileFirstTap(state);
      },
      true
    );

    mediaContainer.addEventListener(
      'pointercancel',
      function () {
        disarmMobileFirstTap(state);
      },
      true
    );

    /*
      Mobile Coccinelle interaction:
      first image tap reveals swatches + second image;
      the following image tap is left untouched and opens the product.
    */
    mediaContainer.addEventListener(
      'click',
      function (event) {
        if (!mobileQuery.matches) return;
        if (event.target.closest('.dh-card-swatches')) return;
        if (state.card.classList.contains('dh-mobile-card-open')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        closeOtherMobileCards(state);
        state.card.classList.add('dh-mobile-card-open');

        window.setTimeout(function () {
          disarmMobileFirstTap(state);
        }, 0);
      },
      true
    );

    // Se il codice originale seleziona una variante, quella diventa la nuova base.
    swatches.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('input[type="radio"][data-image]')) return;

      state.baseImageState = {
        src: input.dataset.image,
        srcset: input.dataset.image
      };
    });

    updateSwatchPosition(state);
  }

  function prepareCards(root) {
    root = root || document;

    if (root.matches && root.matches('.product-card-wrapper')) {
      prepareCard(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.product-card-wrapper').forEach(prepareCard);
    }
  }

  function init() {
    prepareCards(document);

    if (finePointerQuery.addEventListener) {
      finePointerQuery.addEventListener('change', function () {
        cardStates.forEach(updateSwatchPosition);
      });
    } else if (finePointerQuery.addListener) {
      finePointerQuery.addListener(function () {
        cardStates.forEach(updateSwatchPosition);
      });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () {
        cardStates.forEach(updateSwatchPosition);
      });
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(function () {
        cardStates.forEach(updateSwatchPosition);
      });
    }

    document.addEventListener('pointerdown', function (event) {
      if (!mobileQuery.matches) return;

      cardStates.forEach(function (state) {
        if (!state.card.contains(event.target)) closeMobileCard(state);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      prepareCards(event.target);
    });

    /*
      Reset before a page enters Safari's back-forward cache and again when it
      is restored. Without this, the last clicked card can remain locked.
    */
    window.addEventListener('pagehide', resetAllProductNavigationStates);
    window.addEventListener('pageshow', resetAllProductNavigationStates);

    try {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) prepareCards(node);
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
